<template>
  <div ref="whole_page">
    <div class="vx-row mx-auto">
      <div class="vx-col xl:w-1/3 lg:w-1/3 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card id="previous_card" ref="previous_card" class="roster_cards vs-con-loading__container">
          <div class="vx-row mb-5 header-row__with-background-primary">
            <div class="vx-row ml-2">
              <div class="vx-col">
                <h3>Previous</h3>
              </div>
              <div class="vx-col">
                <vs-checkbox class="mt-1" style="align-items: normal;" v-model="showOutstanding">Show Outstanding</vs-checkbox>
              </div>
            </div>
            <vx-card card-background="#11193f" class="card__no-padding mx-8 mt-4">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text school-primary_gradient">
                    <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <v-select 
                  ref="subjectDropdown"
                  class="w-full style-chooser"
                  placeholder="Sort per Subject"
                  :options="subjects_Previous"
                  @search:blur="sortBySubject_Previous"
                  @input="clearSort_Previous"
                  v-model="subjectDropdown_Previous"
                />
              </vx-input-group>
            </vx-card>
          </div>
          <span v-show="previousData.length == 0" class="white-text">No data to display</span>
          <VuePerfectScrollbar class="scroll-area" :settings="settings">
            <div v-for="(item, index) in previousData" :key="index">
              <div class="text-left ml-3" style="display: grid">
                <span class="text__school-font-color"><small>{{ getDate(item.fromDate) + " - " + getDate(item.toDate)  }}</small></span>
                <span class="white-text"><small>{{ item.subjectName }}</small></span>
                <span class="white-text"><small>{{ item.moduleName }}</small></span>
                <span class="white-text"><small>{{ item.topicName }}</small></span>
              </div>
              <!-- structured lesson START -->
              <div v-if="item.hasStructuredLesson && !(item.content.tasks.length == 1 && item.content.tasks[0].liveStream)">
                <vx-card card-background="#262d4a" class="card__no-padding mt-1 mb-2">
                  <vx-input-group class="roster-content__not-done_expired" v-if="!item.structuredLessonHasBeenStarted">
                    <template slot="prepend">
                      <div class="prepend-text" style="width: 70px;background-color: rgba(127, 196, 73, 0.3);border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1 ml-2 content-icon" icon="GridIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full limit-height_content-height button-text__left-align"
                      style="border-radius:0 7px 7px 0;"
                      type="filled"
                      color="rgba(127, 196, 73, 0.3)"
                      @click="goToLesson(item.topicId, item.startTaskDisplayId)">
                      Structured Lesson
                    </vs-button>
                  </vx-input-group>

                  <vx-input-group class="structured-lesson__started" v-else-if="item.structuredLessonHasBeenStarted && !showOutstanding">
                    <template slot="prepend">
                      <div class="prepend-text" style="width: 70px;background-color: rgba(219, 197, 1, 0.3);border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1 ml-2 content-icon" icon="GridIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full limit-height_content-height button-text__left-align"
                      style="border-radius:0 7px 7px 0;"
                      type="filled"
                      color="rgba(219, 197, 1, 0.3)"
                      @click="goToLesson(item.topicId, item.startTaskDisplayId)">
                      Structured Lesson
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
              <!-- structured lesson END -->
              <vx-card card-background="#262d4a" class="card__no-padding mt-1 mb-2" v-for="(_task, _index) in item.content.tasks" :key="_index">
                <vx-input-group class="roster-content__not-done_expired" v-if="!_task.hasBeenDone">
                  <template slot="prepend">
                    <div class="prepend-text" style="width: 70px;background-color: #262d4a;border-radius: 5px 0 0 5px !important;">
                      <span><feather-icon class="pt-1 ml-2 content-icon" :icon="getIcon(_task)" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <vs-button
                    size="large"
                    class="w-full limit-height_content-height button-text__left-align"
                    style="border-radius:0 7px 7px 0;"
                    type="filled"
                    color="#262d4a"
                    @click="contentSelected(_task, _task.index, item.content)">
                    {{ getContentName(_task) }}
                    <p class="pt-1" v-if="$getSiteId() == 21 && _task.isAssessment && _task.upload && _task.upload.id"><strong>Assessment</strong></p>
                    <p class="pt-1" v-if="$getSiteId() == 21 && !_task.isAssessment && _task.upload && _task.upload.id"><strong>Classwork</strong></p>
                    <p class="pt-1" v-if="_task.liveStream.id"><strong>[{{ _task.liveStream.startTime + " - " + _task.liveStream.endTime }}]</strong></p>
                    <p class="pt-1" v-else-if="_task.videoChat.id"><strong>[{{ _task.videoChat.startTime + " - " + _task.videoChat.endTime }}]</strong></p>
                    
                  </vs-button>
                </vx-input-group>

                <vx-input-group class="roster-content__done" v-else>
                  <template slot="prepend">
                    <div class="prepend-text" style="width: 70px;background-color: #262d4a;border-radius: 5px 0 0 5px !important;">
                      <span><feather-icon class="pt-1 ml-2 content-icon" :icon="getIcon(_task)" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <vs-button
                    size="large"
                    class="w-full limit-height_content-height button-text__left-align"
                    style="border-radius:0 7px 7px 0;"
                    type="filled"
                    color="#262d4a"
                    @click="contentSelected(_task, _task.index, item.content)">
                    {{ getContentName(_task) }}
                    <p class="pt-1" v-if="$getSiteId() == 21 && _task.isAssessment && _task.upload && _task.upload.id"><strong>Assessment</strong></p>
                    <p class="pt-1" v-if="$getSiteId() == 21 && !_task.isAssessment && _task.upload && _task.upload.id"><strong>Classwork</strong></p>
                    <p class="pt-1" v-if="_task.liveStream.id"><strong>[{{ _task.liveStream.startTime + " - " + _task.liveStream.endTime }}]</strong></p>
                    <p class="pt-1" v-else-if="_task.videoChat.id"><strong>[{{ _task.videoChat.startTime + " - " + _task.videoChat.endTime }}]</strong></p>
                    
                  </vs-button>
                </vx-input-group>
              </vx-card>
              
              
            </div>
            <!-- ScheduledTasks Begin -->
            <div v-if="getExpiredScheduleTasks().length>0">
              <vs-divider border-style="dashed" />
              <h4 class="w-full limit-height_content-height button-text__left-align">Scheduled Tasks</h4>
            </div>
            
            <vx-card card-background="#262d4a" class="card__no-padding mt-1 mb-2" v-for="(_task, _index) in getExpiredScheduleTasks()" :key="_index+'b'">
              <div class="text-left ml-3" style="display: grid">
                <span class="text__school-font-color"><small>{{ getDate(_task.fromDate) + " - " + getDate(_task.toDate)  }}</small></span>
                <span class="text__school-font-color"><small>{{ _task.fromTime + " - " + _task.toTime }}</small></span>
                <span class="white-text"><small>{{ _task.taskName }}</small></span>
              </div>
              <vx-input-group class="roster-content__not-done_expired" >
                <template slot="prepend">
                  <div class="prepend-text" style="width: 70px;background-color: #262d4a;border-radius: 5px 0 0 5px !important;">
                    <span><feather-icon class="pt-1 ml-2 content-icon" :icon="'UploadIcon'" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full limit-height_content-height button-text__left-align"
                  style="border-radius:0 7px 7px 0;"
                  type="filled"
                  color="#262d4a"
                  disabled
                  >
                  <!-- @click="contentSelected(_task, _task.index, item.content)" -->
                  {{ _task.taskName }}
                  <p class="pt-1" v-if="$getSiteId() == 21 && _task.isAssessment && _task.upload && _task.upload.id"><strong>Assessment</strong></p>
                  <p class="pt-1" v-if="$getSiteId() == 21 && !_task.isAssessment && _task.upload && _task.upload.id"><strong>Classwork</strong></p>
                </vs-button>
              </vx-input-group>
            </vx-card>
          </VuePerfectScrollbar>
        </vx-card>
      </div>

      <div class="vx-col xl:w-1/3 lg:w-1/3 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card id="today_card" ref="today_card" class="roster_cards vs-con-loading__container">
          <div class="vx-row mb-5 header-row__with-background-gray">
            <div class="vx-row ml-2">
              <div class="vx-col" v-if="!hidden">
                <h3>Today</h3>
              </div>
              <div class="vx-col">
                <h3 class="text__school-font-color black">{{ displayDate }}</h3>
              </div>
            </div>

            <vx-card card-background="#11193f" class="card__no-padding mx-8 mt-4">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text school-primary_gradient">
                    <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <v-select 
                  ref="subjectDropdown"
                  class="w-full style-chooser"
                  placeholder="Sort per Subject"
                  :options="subjects"
                  @search:blur="sortBySubject"
                  @input="clearSort"
                  v-model="subjectDropdown"
                />
              </vx-input-group>
            </vx-card>
          </div>
          <span v-show="rosterData.length == 0" class="white-text">No data to display</span>
          <VuePerfectScrollbar class="scroll-area" :settings="settings">
            <div v-for="(item, index) in rosterData" :key="index">
              <div class="text-left ml-3" style="display: grid">
                <span class="text__school-font-color"><small>{{ getDate(item.fromDate) + " - " + getDate(item.toDate)  }}</small></span>
                <span class="white-text"><small>{{ item.subjectName }}</small></span>
                <span class="white-text"><small>{{ item.moduleName }}</small></span>
                <span class="white-text"><small>{{ item.topicName }}</small></span>
              </div>
              <!-- structured lesson START -->
              <div v-if="item.hasStructuredLesson && !(item.content.tasks.length == 1 && item.content.tasks[0].liveStream)">
                <vx-card card-background="#262d4a" class="card__no-padding mt-1 mb-2">
                  <vx-input-group class="structured-lesson__started" v-if="item.structuredLessonHasBeenStarted">
                    <template slot="prepend">
                      <div class="prepend-text" style="width: 70px;background-color: rgba(219, 197, 1, 0.3);border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1 ml-2 content-icon" icon="GridIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full limit-height_content-height button-text__left-align"
                      style="border-radius:0 7px 7px 0;"
                      type="filled"
                      color="rgba(219, 197, 1, 0.3)"
                      @click="goToLesson(item.topicId, item.startTaskDisplayId)">
                      Structured Lesson
                    </vs-button>
                  </vx-input-group>

                  <vx-input-group class="structured-lesson__not-started" v-else>
                    <template slot="prepend">
                      <div class="prepend-text" style="width: 70px;background-color: rgba(127, 196, 73, 0.3);border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1 ml-2 content-icon" icon="GridIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full limit-height_content-height button-text__left-align"
                      style="border-radius:0 7px 7px 0;"
                      type="filled"
                      color="rgba(127, 196, 73, 0.3)"
                      @click="goToLesson(item.topicId, item.startTaskDisplayId)">
                      Structured Lesson
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </div>
              <!-- structured lesson END -->
              <vx-card card-background="#262d4a" class="card__no-padding mt-1 mb-2" v-for="(_task, _index) in item.content.tasks" :key="_index">
                <vx-input-group class="roster-content__done" v-if="_task.hasBeenDone">
                  <template slot="prepend">
                    <div class="prepend-text" style="width: 70px;background-color: #262d4a;border-radius: 5px 0 0 5px !important;">
                      <span><feather-icon class="pt-1 ml-2 content-icon" :class="{'flash-icon' : isLiveStreamOrVideoChatInProgress(_task) }" :icon="getIcon(_task)" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <vs-button
                    size="large"
                    class="w-full limit-height_content-height button-text__left-align"
                    style="border-radius:0 7px 7px 0;"
                    type="filled"
                    color="#262d4a"
                    @click="contentSelected(_task, _task.index, item.content)">
                    {{ getContentName(_task) }}
                    <p class="pt-1" v-if="$getSiteId() == 21 && _task.isAssessment && _task.upload && _task.upload.id"><strong>Assessment</strong></p>
                    <p class="pt-1" v-if="$getSiteId() == 21 && !_task.isAssessment && _task.upload && _task.upload.id"><strong>Classwork</strong></p>
                    <p class="pt-1" v-if="_task.liveStream.id"><strong>[{{ _task.liveStream.startTime + " - " + _task.liveStream.endTime }}]</strong></p>
                    <p class="pt-1" v-else-if="_task.videoChat.id"><strong>[{{ _task.videoChat.startTime + " - " + _task.videoChat.endTime }}]</strong></p>
                    
                  </vs-button>
                </vx-input-group>

                <vx-input-group class="roster-content__not-done" v-else>
                  <template slot="prepend">
                    <div class="prepend-text" style="width: 70px;background-color: #262d4a;border-radius: 5px 0 0 5px !important;">
                      <span><feather-icon class="pt-1 ml-2 content-icon" :class="{'flash-icon' : isLiveStreamOrVideoChatInProgress(_task) }" :icon="getIcon(_task)" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <vs-button
                    size="large"
                    class="w-full limit-height_content-height button-text__left-align"
                    style="border-radius:0 7px 7px 0;"
                    type="filled"
                    color="#262d4a"
                    @click="contentSelected(_task, _task.index, item.content)">
                    {{ getContentName(_task) }}
                    <p class="pt-1" v-if="$getSiteId() == 21 && _task.isAssessment && _task.upload && _task.upload.id"><strong>Assessment</strong></p>
                    <p class="pt-1" v-if="$getSiteId() == 21 && !_task.isAssessment && _task.upload && _task.upload.id"><strong>Classwork</strong></p>
                    <p class="pt-1" v-if="_task.liveStream.id"><strong>[{{ _task.liveStream.startTime + " - " + _task.liveStream.endTime }}]</strong></p>
                    <p class="pt-1" v-else-if="_task.videoChat.id"><strong>[{{ _task.videoChat.startTime + " - " + _task.videoChat.endTime }}]</strong></p>
                  </vs-button>
                </vx-input-group>
              </vx-card>
            </div>

            <!-- ScheduledTasks Begin -->
            <div v-if="getReadyScheduleTasks().length>0">
              <vs-divider border-style="dashed" />
              <h4 class="w-full limit-height_content-height button-text__left-align">Scheduled Tasks</h4>
            </div>
            <vx-card card-background="#262d4a" class="card__no-padding mt-1 mb-2" v-for="(_task, _index) in getReadyScheduleTasks()" :key="_index+'a'">
              <div class="text-left ml-3" style="display: grid">
                <span class="text__school-font-color"><small>{{ getDate(_task.fromDate) + " - " + getDate(_task.toDate)  }}</small></span>
                <span class="text__school-font-color"><small>{{ _task.fromTime + " - " + _task.toTime }}</small></span>
                <span class="white-text"><small>{{ _task.taskName }}</small></span>
              </div>
              <vx-input-group class="roster-content__not-done" >
                <template slot="prepend">
                  <div class="prepend-text" style="width: 70px;background-color: #262d4a;border-radius: 5px 0 0 5px !important;">
                    <span><feather-icon class="pt-1 ml-2 content-icon" :icon="'UploadIcon'" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full limit-height_content-height button-text__left-align"
                  style="border-radius:0 7px 7px 0;"
                  type="filled"
                  color="#262d4a"
                  @click="selectScheduledUploadTask(_task)"
                  :disabled="getTaskShouldBeDisabled(_task)"
                  >
                  <span v-if="!getTaskShouldBeDisabled(_task)">{{ _task.taskName }} : {{_task.fromTime}} <i class="icon feather icon-arrow-right text-white" /> {{_task.toTime}}</span>
                  <span v-if="getTaskShouldBeDisabled(_task)">{{ _task.taskName }} : Task currently unavailable. Refresh when correct time. : {{_task.fromTime}} -> {{_task.toTime}}</span>
                  <div v-if="$getSiteId() == 21 && _task.upload && _task.upload.id">
                    <span v-if="_task.isAssessment"><strong>Assessment</strong></span>
                    <span v-if="!_task.isAssessment"><strong>Classwork</strong></span>
                  </div>
                </vs-button>
              </vx-input-group>
            </vx-card>
          </VuePerfectScrollbar>

        </vx-card>
      </div>

      <div class="vx-col xl:w-1/3 lg:w-1/3 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card id="roster_future" class="roster_cards vs-con-loading__container" style="overflow:auto">
          <div class="vx-row mb-5 header-row__with-background-primary">
            <div class="vx-row ml-2">
              <div class="vx-col">
                <h3>Future</h3>
              </div>
            </div>
          </div>
          <datepicker ref="fromPicker" v-model="selectedDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import moment from 'moment'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  components: {
    Datepicker,
    vSelect,
    moment,
    VuePerfectScrollbar
  },
  data() {
    return {
      format: "yyyy-MM-dd",
      selectedDate: new Date(),
      subjectDropdown: 0,
      subjectDropdown_Previous: 0,
      subjects: [],
      subjects_Previous: [],
      today: null,
      highlightedFn: {
        customPredictor(date) {
          this.today = new Date();
          
          if (date.getDate() == this.today.getDate() && date.getMonth() == this.today.getMonth()) {
            return true;
          }
        }
      },
      previousData: {},
      previousDataOrig: {},
      rosterData: {},
      rosterDataOrig: {},
      hidden: false,
      settings: {
        maxScrollbarLength: 60,
        // wheelSpeed: 0.6
      },
      showOutstanding: false,
      logData: {},
      uuid: null,
      scheduledUploadTasks:[]
    }
  },
  computed: {
    displayDate: function() {
      var self = this;
      if(self.selectedDate) {
        var dateString = new Date(Date.parse(self.selectedDate));

        return moment(dateString.toISOString()).format("ddd, DD MMMM YYYY");
      }
    }
  },
  watch: {
    selectedDate: function(val) {
      this.subjectDropdown = 0;
      this.subjectDropdown_Previous = 0;
      this.getRosterDataForDate(val);
      this.hideTodayLabel(val);
    },
    showOutstanding: function(val) {
      var self = this;
      self.clearSort_Previous();
      self.subjectDropdown_Previous = 0;

      if(val) {
        self.previousData = self.previousDataOrig.map(function(item){
          var _tempItem = JSON.parse(JSON.stringify(item));
          _tempItem.content.tasks = item.content.tasks.filter(function(task) {
            return !task.hasBeenDone
          });
          return _tempItem;
        });
      }
      else {
        self.previousData = self.previousDataOrig;
      }
    }
  },
  methods: {
    getRosterDataForDate(date) {
      var self = this;
      setTimeout(() => {
        
      }, 300);
      self.showLoadingOnElement("today_card", 1, "material");
      self.showLoadingOnElement("previous_card", 1, "material");
      var onSuccess = function (response) {
        var normalRosterData = response.data.rosterData;
        self.scheduledUploadTasks = response.data.scheduledUploadtaskData;
        self.rosterData = normalRosterData.filter(function(item){
          return item.content.tasks.filter(function(task) {
            return !task.expired
          }).length > 0
        });

        self.rosterDataOrig = normalRosterData;

        self.previousData = self.rosterDataOrig.filter(function(item){
          return item.content.tasks.filter(function(task) {
            return task.expired
          }).length > 0
        });
        self.previousDataOrig = self.previousData;
        
        self.setSubjectsList();
        self.setSubjectsList_Previous();
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.today_card.$el);
        self.$vs.loading.close(self.$refs.previous_card.$el);
      };

      var dateObject = new Date(Date.parse(date));
      var formattedDate = moment(dateObject.toISOString()).format('YYYY-MM-DD');
      
      self.$ajaxGet(self, "student/GetRosterForDate?date=" + formattedDate, onSuccess, onFinally);
    },
    hideTodayLabel(val) {
      var self = this;

      var _today = moment(new Date().toISOString()).format("ddd, DD MMMM YYYY");
      var _selectedDate = moment(new Date(Date.parse(val)).toISOString()).format("ddd, DD MMMM YYYY");

      if(_today == _selectedDate)
        self.hidden = false;
      else
        self.hidden = true;
    },
    sortBySubject() {
      var self = this;

      if(self.subjectDropdown) {
        self.rosterData = self.rosterData.filter(function(item) { return item.subjectId == self.subjectDropdown.value });
      }
    },
    clearSort() {
      this.rosterData = this.rosterDataOrig;
    },
    sortBySubject_Previous() {
      var self = this;

      if(self.subjectDropdown_Previous) {
        self.previousData = self.previousData.filter(function(item) { return item.subjectId == self.subjectDropdown_Previous.value });
      }
    },
    clearSort_Previous() {
      this.previousData = this.previousDataOrig;
    },
    getDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    getIcon(task) {
      if(task.video.id)
        return "YoutubeIcon"
      else if(task.document.id)
        return "FileTextIcon"
      else if(task.podcast.id)
        return "MicIcon"
      else if(task.liveStream.id)
        return "VideoIcon"
      else if(task.videoChat.id)
        return "MonitorIcon"
      else if(task.upload.id)
        return "UploadIcon"
      else if(task.quiz.id)
        return "EditIcon"
      else if(task.externalLink.id)
        return "LinkIcon"
    },
    getContentName(task) {
      if(task.video.id)
        return task.video.name;
      else if(task.document.id)
        return task.document.name;
      else if(task.podcast.id)
        return task.podcast.name;
      else if(task.liveStream.id)
        return task.liveStream.title;
      else if(task.videoChat.id)
        return task.videoChat.title;
      else if(task.upload.id)
        return task.upload.name;
      else if(task.quiz.id)
        return task.quiz.name;
      else if(task.externalLink.id)
        return task.externalLink.name;
    },
    isLiveStreamOrVideoChatInProgress(_task) {
      if (_task && _task.liveStream && _task.liveStream.id) {
        var startTime = _task.liveStream.startTime;
        var endTime = _task.liveStream.endTime;

        var startHour = startTime.split(":")[0];
        var startMinutes = startTime.split(":")[1];

        var endHour = endTime.split(":")[0];
        var endMinutes = endTime.split(":")[1];

        var liveStreamDate = _task.liveStream.date;

        var fromLiveStreamDate = new Date(Date.parse(liveStreamDate));
        var toLiveStreamDate = new Date(Date.parse(liveStreamDate));

        fromLiveStreamDate.setHours(startHour);
        fromLiveStreamDate.setMinutes(startMinutes);

        toLiveStreamDate.setHours(endHour);
        toLiveStreamDate.setMinutes(endMinutes);

        var today = new Date();

        if (today >= fromLiveStreamDate && today <= toLiveStreamDate) {
          return true;
        }
      }
      else if (_task && _task.videoChat && _task.videoChat.id) {
        var startTime = _task.videoChat.startTime;
        var endTime = _task.videoChat.endTime;

        var startHour = startTime.split(":")[0];
        var startMinutes = startTime.split(":")[1];

        var endHour = endTime.split(":")[0];
        var endMinutes = endTime.split(":")[1];

        var videoChatDate = _task.videoChat.date;

        var fromVideoChatDate = new Date(Date.parse(videoChatDate));
        var toVideoChatDate = new Date(Date.parse(videoChatDate));

        fromVideoChatDate.setHours(startHour);
        fromVideoChatDate.setMinutes(startMinutes);

        toVideoChatDate.setHours(endHour);
        toVideoChatDate.setMinutes(endMinutes);

        var today = new Date();

        if (today >= fromVideoChatDate && today <= toVideoChatDate) {
          return true;
        }
      }
      return false;
    },
    contentSelected(task, index, standaloneContentDto) {
      if (task.video.id) {
        this.$router.push({
          name: "VideoViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            // selectedData: selectedData
          },
          query:{"id":task.id}
        });
      }
      else if (task.document.id) {
        this.$router.push({
          name: "DocumentViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            // selectedData: selectedData
          },
          query:{"id":task.id}
        });
      }
      else if (task.podcast.id) {
        this.$router.push({
          name: "PodcastViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            // selectedData: selectedData
          },
          query:{"id":task.id}
        });
      }
      else if (task.liveStream.id) {
        this.$router.push({
          name: "LiveStreamViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            // selectedData: selectedData
          },
          query:{"id":task.id}
        });
      }
      else if (task.videoChat.id) {
        this.$router.push({
          name: "VideoChatPage",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            // selectedData: selectedData
          },
          query:{"id":task.id}
        });
      }
      else if (task.upload.id) {
        this.$router.push({
          name: "UploadViewer",
          params: {
            index: index,
            standaloneContent: standaloneContentDto,
            // selectedData: selectedData
          },
          query:{"id":task.id}
        });
      }
      else if (task.quiz.id) {
        var selectedModuleID ;

        this.rosterData.forEach(e => {
          e.content.tasks.forEach(element => {
            if(element.id == task.quiz.id)
            {
              selectedModuleID = e.topicId;
            }
          });
        });

        this.getQuiz(task.quiz.id,selectedModuleID);
      }
      else if (task.externalLink.id) {
        this.logExternalLink(task.externalLink.id, task.externalLink.url);
      }
    },
    selectScheduledUploadTask(task){
      this.$router.push({
        name: "UploadViewer",
        params: {
          index: 0,
          standaloneContent: {tasks:[task]},
          // selectedData: selectedData
        },
        query:{"id":task.TaskId}
      });
    },
    logExternalLink(taskId, url) {
      var self = this;
        
      self.uuid = self.$uuid.v4();
      self.logData.taskId = taskId;
      self.logData.logIdentifier = self.uuid;
      self.logData.toTaskId = null;
      self.logData.fromTaskId = null;

      var onSuccess = function(response) {
        self.$ajaxPost(self, "ExternalLinkTask/EndLogEntry", self.logData, function() { window.open(url, "_blank"); });
      };
      
      self.$ajaxPost(self, "ExternalLinkTask/StartLogEntry", self.logData, onSuccess);
    },
    setSubjectsList() {
      var self = this;

      var temp_subjects = self.rosterData.map(function(item) { return { label: item.subjectName, value: item.subjectId } });

      temp_subjects.forEach(_subject => {
        if (
          self.subjects.filter(function(item) {
            return _subject.value == item.value;
          }).length == 0
        )
          self.subjects.push(_subject);
      });
    },
    setSubjectsList_Previous() {
      var self = this;
      
      var temp_subjects = self.previousData.map(function(item) { return { label: item.subjectName, value: item.subjectId } });
      temp_subjects.forEach(_subject => {
        if (
          self.subjects.filter(function(item) {
            return _subject.value == item.value;
          }).length == 0
        )
          self.subjects_Previous.push(_subject);
      });
    },
    goToLesson(topicId, startTaskDisplayId) {
      var self = this;
      var moduleId = topicId;
      var taskDisplayId = startTaskDisplayId;

      var lastTask = localStorage.getItem("lastTask");
      var lastModule = localStorage.getItem("lastModule");

      if(lastModule && lastModule.toString() == moduleId.toString()) {
        if(lastTask) {
          moduleId = lastModule;
          taskDisplayId = lastTask;
        }
      }

      localStorage.setItem("currentModule", moduleId);
      self.$router.push({ name: 'DigiStoryViewer', params: { mode: "story", taskDisplayId: taskDisplayId, moduleId: moduleId, isStudent: "true" } });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    getQuiz(quizId, moduleId){
      const self = this; 
      var onSuccess = function(response) {
        self.quiz = response.data;

        self.$router.push({
          name: "QuizTaskViewer",
          params: {
            taskId: quizId,
            moduleId: moduleId,
            quiz: self.quiz,
          },
          query:{"id":quizId}
        });
        
      };

      if(quizId){
        self.$ajaxGet( self,"Student/GetQuizTask?moduleId=" + moduleId + "&quizTaskId=" + quizId ,onSuccess);
      }
    },
    getExpiredScheduleTasks(){
      var self = this;
      var currentDate = new Date(Date.parse(self.selectedDate));

      var result = self.scheduledUploadTasks.filter(
        function(item)
        {
          var fromTime = item.fromTime.split(':');
          var fromDate = new Date(item.fromDate);
          fromDate.setHours(fromTime[0], fromTime[1], fromTime[2]);

          var toTime = item.toTime.split(':');
          var toDate = new Date(item.toDate);
          toDate.setHours(toTime[0], toTime[1], toTime[2]);

          if(toDate<= currentDate){
            return true;
          }else{
            return false;
          }
        });
      return result;
    },
    getReadyScheduleTasks(){
      var self = this;
      console.log
      var currentDate = new Date(Date.parse(self.selectedDate));
      var result = self.scheduledUploadTasks.filter(
        function(item)
        {
          var fromDate = new Date(item.fromDate);
          fromDate.setHours(0, 0, 0);

          var toDate = new Date(item.toDate);
          toDate.setHours(23, 59, 59);

          if(fromDate<=currentDate && toDate>= currentDate){
            return true;
          }else{
            return false;
          }
        });
      return result;
    },
    getTaskShouldBeDisabled(task){
      var currentDate = new Date();

      var fromTime = task.fromTime.split(':');
      var fromDate = new Date(task.fromDate);
      fromDate.setHours(fromTime[0], fromTime[1], fromTime[2]);

      var toTime = task.toTime.split(':');
      var toDate = new Date(task.toDate);
      toDate.setHours(toTime[0], toTime[1], toTime[2]);

      if(fromDate<=currentDate && toDate>= currentDate){
        return false;
      }else{
        return true;
      }
    }
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    var now = new Date();
    self.selectedDate = now.toString();
  }
};
</script>
<style lang="scss">
  #previous_card {
    .scroll-area {
      position: relative;
      height: 75%;
      padding-bottom: 100px;
    }

    .vx-card__collapsible-content {
      height: inherit !important;

      .vx-card__body {
        height: inherit !important;
      }
    }
  }

  #today_card {
    .scroll-area {
      position: relative;
      height: 75%;
      padding-bottom: 100px;
    }

    .vx-card__collapsible-content {
      height: inherit !important;

      .vx-card__body {
        height: inherit !important;
      }
    }
  }

  .flash-icon {
    animation: blinker 1.3s linear infinite;
    color: rgb(255, 0, 0) !important;
  }

  @keyframes blinker {
    50% {
      opacity: 0.4;
    }
  }
</style>